import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "saleBillerSelector", "saleSummary", "allSaleSummary" ]

  connect() {
    this.filterSaleSummaries();
  }

  filterSaleSummaries() {
    const selectedBillerId = this.saleBillerSelectorTarget.value;

    this.allSaleSummaryTarget.style.display = "none";
    this.saleSummaryTargets.forEach(summary => summary.style.display = "none");

    if (selectedBillerId === "all") {
      this.allSaleSummaryTarget.style.display = "block";
    } else if (selectedBillerId) {
      const summary = this.saleSummaryTargets.find(
        s => s.dataset.billerId === selectedBillerId
      );
      if (summary) summary.style.display = "block";
    }
  }
}
